import { Injectable } from '@angular/core';
import ErrorHandling from 'src/app/shared/Utility/ErrorHandling';
import { describeNotebookDownloadForLog, NotebookDownloadState } from './notebook-download-state';

export const NOTEBOOK_DOWNLOAD_LOG_SOURCE = 'NotebookDownload';

@Injectable({
  providedIn: 'root',
})
export class NotebookDownloadTelemetry {
  constructor(private readonly errorHandling: ErrorHandling) {}

  failure(state: NotebookDownloadState, now: number): void {
    this.errorHandling.LogErrorToServer(describeNotebookDownloadForLog(state, now, 'failed'), null);
  }

  notice(state: NotebookDownloadState, now: number, detail: string): void {
    this.errorHandling.LogMessageToServer(describeNotebookDownloadForLog(state, now, detail), NOTEBOOK_DOWNLOAD_LOG_SOURCE);
  }
}
